import React from "react";

// The one page shell for every list / operations screen.
//
// Before this, every screen invented its own wrapper: `space-y-6 px-4 py-6`,
// `px-4 py-6`, `min-h-screen bg-gray-100`, `p-6`, `min-h-screen` ... which is
// why the same list looked like it belonged to a different app depending on
// which menu item you came from. The reference is the ChequeGuard Bank screen
// (decision 9.3), so that is what this renders.
//
//   <PageContainer>
//     <PageHeader title="Banks" actions={...} />
//     <BanksTable ... />
//   </PageContainer>
//
// `spacing` is there for the few screens that were deliberately tighter
// (Branches used space-y-4); everything else takes the default.
const PageContainer = ({ children, className = "", spacing = "space-y-6" }) => (
  <div className={`${spacing} px-4 py-6 ${className}`.trim()}>{children}</div>
);

export default PageContainer;
